<template>
  <v-select
    :items="items"
    :label="label"
    v-model="item"
    @change="updateValue"
  ></v-select>
</template>

<script>
export default {
  name: "year-select",
  props: {
    label: {
      type: String,
      default: "Anno",
    },
    n: {
      type: Number,
      default: 5,
    },
    value: Number,
  },
  mounted() {
    if (this.value) {
      this.item = this.value;
    }
    const currentYear = new Date().getFullYear();
    this.items = [];
    for (let index = 0; index < this.n; index++) {
      this.items.push(currentYear - index);
    }
  },
  data() {
    return {
      item: null,
      items: [],
    };
  },
  methods: {
    updateValue(value) {
      this.$emit("input", value);
      this.$emit("updated");
    },
  },
  watch: {
    value(val) {
      this.item = val;
    },
  },
};
</script>

<style></style>
